import { enUS, es, ja, pt } from 'date-fns/locale';

interface TimeFormatData {
    format: string;
    locale: string;
}
const getTimeFormatFromLocale = (): TimeFormatData => {
    let { language } = window.navigator;
    if (language.length > 2) {
        language = language.substr(0, 2);
    }

    const languageDateModules = {
        en: {
            locale: enUS,
            format: 'MM/dd/yyyy'
        },
        es: {
            locale: es,
            format: 'dd/MM/yyyy'
        },
        ja: {
            locale: ja,
            format: 'yyyy年MM月dd日'
        },
        pt: {
            locale: pt,
            format: 'dd/MM/yyyy'
        }
    };

    return languageDateModules[language] ?? languageDateModules.en;
};

export default getTimeFormatFromLocale;
